import {Component, Injectable} from "@angular/core";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ModalBase} from "../../../services/modal/modal-base";
import * as semver from "semver";
import {ConfigLevelType} from "../../../services/dtos/enums/config-level-type.enum";
import {RootDeploymentNode} from "../../deployment/deployment-tree/root-deployment-node";
import {InstallType} from "../../../services/dtos/enums/install-type.enum";
import {DeploymentUtilitiesService} from "../../../services/deployment-utilities.service";

@Component({
    selector: 'deployment-confirmation-modal',
    template: require('./deployment-confirmation.modal.component.html'),
    styles: [ require('./deployment-confirmation.modal.component.css') ]
})
export class DeploymentConfirmationModalComponent {
    rootNode: RootDeploymentNode;

    title: string;
    version: string;

    doUpdates: boolean = true;
    doReinstalls: boolean = false;
    doDowngrades: boolean = true;

    currentDeployments: number;
    levelName: string;

    constructor(
        private deploymentUtilitiesService: DeploymentUtilitiesService,
        public activeModal: NgbActiveModal
    ) {}

    getWarning() : string {
        return `Performing a batch deployment of ${this.levelName}'s applications to v${semver.coerce(this.version)} will result in the following actions:`
    }

    isDeployDisabled() : boolean {
        let noUpdates = !this.doUpdates || this.deploymentUtilitiesService.getApplicationsForNode(this.rootNode, true, InstallType.Upgrade, this.version).length < 1;
        let noReinstalls = !this.doReinstalls || this.deploymentUtilitiesService.getApplicationsForNode(this.rootNode, true, InstallType.Reinstall, this.version).length < 1
        let noDowngrades = !this.doDowngrades || this.deploymentUtilitiesService.getApplicationsForNode(this.rootNode, true, InstallType.Downgrade, this.version).length < 1

        return noUpdates && noReinstalls && noDowngrades;
    }

    update() {
        let result = [];

        if (this.doDowngrades)
            result.push(...this.deploymentUtilitiesService.getApplicationsForNode(this.rootNode, true, InstallType.Downgrade, this.version));

        if (this.doReinstalls)
            result.push(...this.deploymentUtilitiesService.getApplicationsForNode(this.rootNode, true, InstallType.Reinstall, this.version));

        if (this.doUpdates)
            result.push(...this.deploymentUtilitiesService.getApplicationsForNode(this.rootNode, true, InstallType.Upgrade, this.version));

        this.activeModal.close(result);
    }

    // required to access InstallType enum in html
    get installType(): typeof InstallType {
        return InstallType;
    }
}

@Injectable()
export class DeploymentConfirmationModal extends ModalBase {
    constructor(modalService: NgbModal) {
        super(modalService, DeploymentConfirmationModalComponent)
    }
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/modals/deployment-confirmation/deployment-confirmation.modal.component.ts